// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';
import { forwardRef } from 'react';

// ----------------------------------------------------------------------

export const StyledNavItem = styled(
    forwardRef((props, ref) => (
        <ListItemButton ref={ref} disableGutters {...props} />
    ))
)(({ theme }) => ({
    ...theme.typography.body2,
    // 48px rows at 14px filled the viewport with a dozen entries and pushed the
    // rest of a thirty-page menu below the fold.
    'fontSize': theme.typography.pxToRem(13),
    'height': 40,
    'position': 'relative',
    'color': theme.palette.text.secondary,
    'borderRadius': theme.shape.borderRadius,

    // The active page was marked with a grey `action.selected` fill, so the one
    // piece of state the sidebar exists to communicate was rendered in the same
    // colour as a hover. Brand colour now carries it, with a left bar that
    // survives being scanned quickly down a long menu.
    '&.active': {
        'color': theme.palette.primary.main,
        'backgroundColor': theme.palette.primary.tint6,
        'fontWeight': theme.typography.fontWeightMedium,
        '&:hover': {
            backgroundColor: theme.palette.primary.tint12
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 8,
            bottom: 8,
            width: 3,
            borderRadius: 2,
            backgroundColor: theme.palette.primary.main
        }
    }
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
    width: 20,
    height: 20,
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
